var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import Row from "reactstrap/lib/Row";
import Col from "reactstrap/lib/Col";
import teamInfo from "./teamInfo";

import styles from "./About.css";

var Team = function (_Component) {
  _inherits(Team, _Component);

  function Team() {
    _classCallCheck(this, Team);

    return _possibleConstructorReturn(this, (Team.__proto__ || Object.getPrototypeOf(Team)).apply(this, arguments));
  }

  _createClass(Team, [{
    key: "render",
    value: function render() {
      return React.createElement(
        "div",
        { className: styles.aboutSections },
        React.createElement(
          "div",
          { className: styles.sectionHeaders },
          React.createElement(
            "h4",
            null,
            "Team"
          )
        ),
        React.createElement(
          "div",
          { className: styles.aboutContent },
          React.createElement(
            Row,
            null,
            teamInfo.map(function (person, index) {
              return React.createElement(
                Col,
                { key: index, md: "4", lg: "4", sm: "6", xs: "6" },
                React.createElement(
                  "div",
                  null,
                  React.createElement("img", { src: person.picture, className: styles.teamPics })
                ),
                React.createElement(
                  "div",
                  { className: styles.teamNames },
                  person.name
                ),
                React.createElement(
                  "div",
                  { className: styles.teamTitles },
                  person.title
                )
              );
            })
          )
        )
      );
    }
  }]);

  return Team;
}(Component);

export default Team;


// WEBPACK FOOTER //
// ./src/about/components/About/Team.js